import React from 'react'
import { Row, Container, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <>
      <main className="footer mt-5 border-top border-warning">
        <Container className="my-4">
          <Row>
            <Col className="d-flex justify-content-center align-items-center flex-column flex-md-row">
              <span className="mx-3">
                Copyright © 2025 All rights reserved.
              </span>
              <div className="mt-2 mt-md-0">
                <Link to="/privacy" className="mx-2">
                  隱私權政策
                </Link>
                <span> | </span>
                <Link to="/terms" className="mx-2">
                  使用條款
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </main>
    </>
  )
}

export default Footer
